// @flow

import { css } from '@emotion/core'
import { ThemeProvider } from 'emotion-theming'
import * as React from 'react'
import styled from '@emotion/styled'

import { Button, Footer, Navigation, Icon, hooks } from '@toggl/ui'
import { themes, variables, media } from '@toggl/style'
import { Link, withPrefix } from 'gatsby'
import type { NavigationType } from '../types'
// import { keyframes } from '@emotion/core'
// $FlowFixMe
import yamlData from '../../data/global/layout.yml'

type Props = {
  Hero: React.ComponentType<any>,
  children?: React.Node,
  background?: string,
  offsetTop?: number,
}

const globalWidth = css`
  width: 85px;
  svg {
    width: 100%;
  }
`

const IconGlobal = () => {
  return (
    <div css={globalWidth}>
      <Icon.Global />
    </div>
  )
}

const navigation: NavigationType = yamlData.navigation

const contents = {
  products: (
    <Navigation.MenuContent
      title={navigation.products.title}
      description={navigation.products.subtitle}
    >
      <Navigation.ProductsGroup>
        {navigation.products.items?.map((item, index) => {
          return (
            <Link key={index} to={item.url}>
              <Navigation.Product
                key={index}
                // $FlowFixMe[unsupported-syntax]
                img={require(`assets/uploads/${item.image}`)}
                title={item.title}
                description={item.subtitle}
              />
            </Link>
          )
        })}
      </Navigation.ProductsGroup>
    </Navigation.MenuContent>
  ),
  login: (
    <Navigation.MenuContent
      title={navigation.login.title}
      description={navigation.login.subtitle}
    >
      <Navigation.ProductsGroup>
        {navigation.login.items?.map((item, index) => {
          return (
            <Link key={index} to={item.url}>
              <Navigation.Product
                // $FlowFixMe[unsupported-syntax]
                img={require(`assets/uploads/${item.image}`)}
                title={item.title}
                description={item.subtitle}
              />
            </Link>
          )
        })}
      </Navigation.ProductsGroup>
    </Navigation.MenuContent>
  ),
  productsCta: <></>,
}

contents.productsCta = contents.products

const LayoutGlobal = ({ children, Hero, background, offsetTop }: Props) => {
  const [contentKey, _setContentKey] = React.useState(null)
  const [contentPadding, setContentPadding] = React.useState()
  const isDesktop = hooks.useMediaQuery(media.mqbp[1])
  const setContentKey = (val) => {
    if (contentKey === val || (val && !contents[val])) {
      return _setContentKey(null)
    }
    _setContentKey(val)
  }
  return (
    <ThemeProvider theme={themes.global}>
      <Hero>
        <Navigation.Header
          onToggle={(isOpen) => {
            if (!isOpen) {
              setContentKey(null)
            }
          }}
          open={!!contentKey}
          background={background}
          setContentPadding={setContentPadding}
          linksMinWidths={{ tablet: '420px', desktop: '500px' }}
          Logo={({ ...props }) => (
            <Link to={'/'}>
              <Icon.Global {...props} />
            </Link>
          )}
          login={
            <Button.HeaderButtonWrapper underlined={contentKey === 'login'}>
              <a onClick={() => setContentKey('login')}>
                Login
                {isDesktop &&
                  (contentKey === 'login' ? (
                    <Icon.Up />
                  ) : (
                    <Icon.Down dark={!!contentKey} />
                  ))}
                {!isDesktop && <Icon.CaretRight />}
              </a>
            </Button.HeaderButtonWrapper>
          }
          Cta={() => (
            <Button.Primary onClick={() => setContentKey('productsCta')}>
              Try Toggl
            </Button.Primary>
          )}
        >
          <Button.HeaderButtonWrapper underlined={contentKey === 'products'}>
            <a onClick={() => setContentKey('products')}>
              Products
              {isDesktop &&
                (contentKey === 'products' ? (
                  <Icon.Up />
                ) : (
                  <Icon.Down dark={!!contentKey} />
                ))}
              {!isDesktop && <Icon.CaretRight />}
            </a>
          </Button.HeaderButtonWrapper>
          <a href={'https://toggl.com/blog/'} rel="noreferrer" target="_blank">
            Blog
          </a>
          <Link to={'/mission/'}>Our mission</Link>
          <Link to={'/jobs/'}>Working at Toggl</Link>
        </Navigation.Header>
      </Hero>
      <Navigation.ExpandedMenu
        onClose={() => setContentKey(null)}
        top={[
          variables.headerHeight,
          variables.headerHeightDesktop + (offsetTop || 0),
        ]}
        contentPadding={contentPadding}
      >
        {contentKey && contents[contentKey]}
      </Navigation.ExpandedMenu>

      <MainContent>
        <Body>{children}</Body>
        <Footer.Wrapper
          Link={Link}
          logo={<IconGlobal />}
          products={[
            <>
              <Link to={'/track/'} key="track">
                <Icon.Track />
                <span>Effortless time tracking</span>
              </Link>
            </>,
            <>
              <a href={withPrefix('/plan/')} key="plan">
                <Icon.Plan />
                <span>Beautifully simple project planning</span>
              </a>
            </>,
            <>
              <a href={withPrefix('/hire/')} key="hire">
                <Icon.Hire />
                <span>Intelligent candidate-screening</span>
              </a>
            </>,
          ]}
        />
      </MainContent>
    </ThemeProvider>
  )
}

const MainContent = styled.div``
const Body = styled.div``

export default LayoutGlobal
